import keyBy from 'lodash/keyBy';

import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import { Stack, Typography } from '@lyearn/ui';
import { CorrectImageHotspotAnswersFragment } from '@/modules/corporate/modules/quiz/views/QuizPlayer/graphql/fragments/generated/QuestionPerformance';
import { QuizPlayerQuestionContentFragment } from '@/modules/corporate/modules/quiz/views/QuizPlayer/graphql/fragments/generated/QuizPlayerQuestionContent';

import AnswerMap from '../../../fill-in-the-blanks/QuestionReview/AnswerMap';

interface CorrectAnswersProps {
  className?: string;
  imageHotspotComponents: QuizPlayerQuestionContentFragment['imageHotspotComponents'];
  correctImageHotspotAnswers: CorrectImageHotspotAnswersFragment[];
}

const CorrectAnswers: React.FC<CorrectAnswersProps> = ({
  className,
  imageHotspotComponents,
  correctImageHotspotAnswers,
}) => {
  const { t } = useTranslation();
  const correctAnswersById = keyBy(correctImageHotspotAnswers, 'id');

  return (
    <Stack
      className={cn(
        'p-12 rounded-6 border border-border-success-dark bg-bg-success-light',
        className,
      )}
      direction="col"
      gapY={12}>
      <Typography color="text-text-success-dark" variant="body-short-02">
        {t('QuizPlayer:CorrectAnswer')}
      </Typography>
      {imageHotspotComponents.map((imageHotspotComponent, index) => {
        const correctAnswer = correctAnswersById[imageHotspotComponent.id];

        return (
          <AnswerMap
            key={imageHotspotComponent.id}
            labelLeft={`${index + 1}`}
            labelRight={correctAnswer.text || ''}
          />
        );
      })}
    </Stack>
  );
};

export default CorrectAnswers;
